/**
 * Analytics · Search Analytics
 * Demo content - see src/demo/analytics.ts.
 */

import React from 'react';
import { AppShell } from '../../components/shell/AppShell';
import { Card, Kpi, PageHead, Table, Tag, Note, DemoBadge } from '../../components/ui';
import { ChartFrame, AreaTrend, Bars } from '../../components/charts';
import { SEARCH } from '../../demo/analytics';

export const SearchAnalyticsPage: React.FC = () => (
  <AppShell
    title="Search Analytics"
    sub="Analytics"
    actions={
      <>
        <DemoBadge />
        <button className="btn btn-g">Last 8 weeks</button>
      </>
    }
  >
    <PageHead
      eyebrow="Analytics"
      title="What people are asking"
      lede="Every question, whether it could be answered, and how long it took. The questions that fail are the more useful half: they show which system you have not connected yet."
    />

    <div className="g g4" style={{ marginBottom: 12 }}>
      {SEARCH.kpis.map((k) => (
        <Kpi
          key={k.label}
          label={k.label}
          value={k.value}
          unit={'unit' in k ? (k as any).unit : undefined}
          color={k.color}
          icon={k.icon as any}
          pip={'pip' in k ? (k as any).pip : undefined}
          dir={('dir' in k ? (k as any).dir : '') as any}
          sub={'sub' in k ? (k as any).sub : undefined}
        />
      ))}
    </div>

    <div className="g g2" style={{ marginBottom: 12 }}>
      <ChartFrame title="Questions asked" sub="per week">
        <AreaTrend data={SEARCH.volume} x="week" series={[{ key: 'questions', label: 'Questions' }]} />
      </ChartFrame>

      <ChartFrame title="What kind of question" sub="share of all questions, %">
        <Bars data={SEARCH.intents} x="intent" horizontal series={[{ key: 'share', label: 'Share' }]} unit="%" />
      </ChartFrame>
    </div>

    <div className="g g3">
      <div className="s2">
        <Card title="Most asked" sub="with answer rate and latency" flush>
          <Table
            cols={[
              { t: 'Question' },
              { t: 'Asked', num: true },
              { t: 'Answered' },
              { t: 'Median time', num: true },
            ]}
            rows={SEARCH.topQuestions.map((q) => [
              <b>{q.q}</b>,
              q.asked,
              <Tag tone={q.tone as any}>{q.answered}</Tag>,
              q.latency,
            ])}
          />
        </Card>
      </div>

      <Card title="Asked, but not answerable" sub="no source holds it">
        {SEARCH.gaps.map((g) => (
          <div className="li" key={g.q}>
            <div style={{ flex: 1 }}>
              <h5>{g.q}</h5>
              <p>{g.reason}</p>
            </div>
            <div className="rt">{g.asked}×</div>
          </div>
        ))}
        <Note style={{ marginTop: 10 }}>
          These are the questions OmniMind declined rather than guessed. Each one is a candidate for
          the next connector.
        </Note>
      </Card>
    </div>
  </AppShell>
);
